import React, { useState,useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
  Card,
  Stack,
  alpha,
  styled,
  Radio,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import TextField from '@mui/material/TextField';

const themes = [
  // Google Material Design Inspired
  {
    id: 'google-blue',
    name: 'Google Blue',
    bg: '#ffffff',
    gradientBg: 'linear-gradient(135deg, #ffffff 0%, #f8faff 100%)',
    textColor: '#202124',
    borderColor: '#dadce0',
    inputBg: '#ffffff',
    accentColor: '#1a73e8',
    secondaryColor: '#4285f4',
    backgroundImage: null
  },
  {
    id: 'google-workspace',
    name: 'Google Workspace',
    bg: '#ffffff',
    gradientBg: 'linear-gradient(135deg, #ffffff 0%, #f9fbff 100%)',
    textColor: '#3c4043',
    borderColor: '#e8eaed',
    inputBg: '#ffffff',
    accentColor: '#1a73e8',
    secondaryColor: '#34a853',
    backgroundImage: null
  },

  // Slack Inspired
  {
    id: 'slack-modern',
    name: 'Slack Modern',
    bg: '#ffffff',
    gradientBg: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    textColor: '#1d1c1d',
    borderColor: '#e1e5e9',
    inputBg: '#ffffff',
    accentColor: '#4a154b',
    secondaryColor: '#007a5a',
    backgroundImage: null
  },

  // Notion Inspired
  {
    id: 'notion-clean',
    name: 'Notion Clean',
    bg: '#ffffff',
    gradientBg: 'linear-gradient(135deg, #ffffff 0%, #fafafa 100%)',
    textColor: '#37352f',
    borderColor: '#e9e9e7',
    inputBg: '#ffffff',
    accentColor: '#2eaadc',
    secondaryColor: '#0f7b0f',
    backgroundImage: null
  },

  // Linear Inspired
  {
    id: 'linear-purple',
    name: 'Linear Purple',
    bg: '#fcfcfd',
    gradientBg: 'linear-gradient(135deg, #fcfcfd 0%, #f7f8fc 100%)',
    textColor: '#16171a',
    borderColor: '#e6e8eb',
    inputBg: '#ffffff',
    accentColor: '#5e6ad2',
    secondaryColor: '#9333ea',
    backgroundImage: null
  },

  // Stripe Inspired
  {
    id: 'stripe-blue',
    name: 'Stripe Blue',
    bg: '#ffffff',
    gradientBg: 'linear-gradient(135deg, #ffffff 0%, #f6f9fc 100%)',
    textColor: '#32325d',
    borderColor: '#e6ebf1',
    inputBg: '#ffffff',
    accentColor: '#635bff',
    secondaryColor: '#0570de',
    backgroundImage: null
  },

  // GitHub Inspired
  {
    id: 'github-modern',
    name: 'GitHub Modern',
    bg: '#ffffff',
    gradientBg: 'linear-gradient(135deg, #ffffff 0%, #f6f8fa 100%)',
    textColor: '#24292f',
    borderColor: '#d0d7de',
    inputBg: '#ffffff',
    accentColor: '#2da44e',
    secondaryColor: '#0969da',
    backgroundImage: null
  },

  // Dark Themes
  {
    id: 'dark-modern',
    name: 'Modern Dark',
    bg: '#0d1117',
    gradientBg: 'linear-gradient(135deg, #0d1117 0%, #161b22 100%)',
    textColor: '#f0f6fc',
    borderColor: '#30363d',
    inputBg: '#21262d',
    accentColor: '#238636',
    secondaryColor: '#2f81f7',
    backgroundImage: null
  },

  {
    id: 'discord-dark',
    name: 'Discord Dark',
    bg: '#36393f',
    gradientBg: 'linear-gradient(135deg, #36393f 0%, #2f3136 100%)',
    textColor: '#dcddde',
    borderColor: '#40444b',
    inputBg: '#40444b',
    accentColor: '#5865f2',
    secondaryColor: '#57f287',
    backgroundImage: null
  },

  // Colorful Professional Themes
  {
    id: 'figma-purple',
    name: 'Figma Purple',
    bg: '#ffffff',
    gradientBg: 'linear-gradient(135deg, #ffffff 0%, #f8f7ff 100%)',
    textColor: '#2c2c2c',
    borderColor: '#e6e6e6',
    inputBg: '#ffffff',
    accentColor: '#a259ff',
    secondaryColor: '#f24e1e',
    backgroundImage: null
  },

  {
    id: 'spotify-green',
    name: 'Spotify Green',
    bg: '#ffffff',
    gradientBg: 'linear-gradient(135deg, #ffffff 0%, #f8fdf9 100%)',
    textColor: '#191414',
    borderColor: '#e5e5e5',
    inputBg: '#ffffff',
    accentColor: '#1db954',
    secondaryColor: '#1ed760',
    backgroundImage: null
  },

  {
    id: 'twitter-blue',
    name: 'Twitter Blue',
    bg: '#ffffff',
    gradientBg: 'linear-gradient(135deg, #ffffff 0%, #f7f9fa 100%)',
    textColor: '#14171a',
    borderColor: '#e1e8ed',
    inputBg: '#ffffff',
    accentColor: '#1da1f2',
    secondaryColor: '#657786',
    backgroundImage: null
  },

  // Warm Themes
  {
    id: 'warm-sunset',
    name: 'Warm Sunset',
    bg: '#fffdf7',
    gradientBg: 'linear-gradient(135deg, #fffdf7 0%, #fef7ed 100%)',
    textColor: '#78716c',
    borderColor: '#f3f4f6',
    inputBg: '#ffffff',
    accentColor: '#f97316',
    secondaryColor: '#ea580c',
    backgroundImage: null
  },

  {
    id: 'forest-green',
    name: 'Forest Green',
    bg: '#f8fffe',
    gradientBg: 'linear-gradient(135deg, #f8fffe 0%, #f0fdf4 100%)',
    textColor: '#374151',
    borderColor: '#d1fae5',
    inputBg: '#ffffff',
    accentColor: '#059669',
    secondaryColor: '#10b981',
    backgroundImage: null
  },

  // Gradient Themes
  {
    id: 'ocean-breeze',
    name: 'Ocean Breeze',
    bg: '#ffffff',
    gradientBg: 'linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)',
    textColor: '#0c4a6e',
    borderColor: '#7dd3fc',
    inputBg: '#ffffff',
    accentColor: '#0369a1',
    secondaryColor: '#0284c7',
    backgroundImage: null
  },

  {
    id: 'lavender-mist',
    name: 'Lavender Mist',
    bg: '#ffffff',
    gradientBg: 'linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%)',
    textColor: '#581c87',
    borderColor: '#d8b4fe',
    inputBg: '#ffffff',
    accentColor: '#7c3aed',
    secondaryColor: '#8b5cf6',
    backgroundImage: null
  }
];

const ThemeCard = styled(Card)(({ theme, isSelected, themeColors }) => ({
  cursor: 'pointer',
  padding: theme.spacing(2.5),
  background: themeColors.gradientBg,
  border: `2px solid ${isSelected ? themeColors.accentColor : 'transparent'}`,
  borderRadius: 16,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'relative',
  overflow: 'visible',
  minHeight: 220,
  '&:hover': {
    transform: 'translateY(-6px)',
    boxShadow: `0 12px 40px ${alpha(themeColors.accentColor, 0.2)}`
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: -3,
    left: -3,
    right: -3,
    bottom: -3,
    borderRadius: 18,
    background: isSelected ? 
      `linear-gradient(135deg, ${themeColors.accentColor}, ${alpha(themeColors.accentColor, 0.6)})` : 
      'transparent',
    opacity: isSelected ? 1 : 0,
    transition: 'opacity 0.3s ease-in-out',
    zIndex: -1
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: 16,
    background: isSelected ? 
      `linear-gradient(135deg, ${alpha(themeColors.accentColor, 0.1)}, transparent)` : 
      'transparent',
    opacity: isSelected ? 1 : 0,
    transition: 'opacity 0.3s ease-in-out',
    pointerEvents: 'none'
  }
}));

const PreviewSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 12,
  transition: 'all 0.2s ease-in-out',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'transparent',
    cursor: 'not-allowed',
    zIndex: 1
  },
  '& .MuiFormControl-root, & .MuiButton-root, & .MuiRadio-root, & .MuiCheckbox-root': {
    pointerEvents: 'none'
  }
}));

const StyledTextField = styled(TextField)(({ theme, themeColors }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: themeColors.inputBg,
    color: themeColors.textColor,
    '& fieldset': {
      borderColor: themeColors.borderColor,
    },
    '&:hover fieldset': {
      borderColor: themeColors.accentColor,
    },
    '& input': {
      color: themeColors.textColor,
    },
    '& input::placeholder': {
      color: alpha(themeColors.textColor, 0.5),
    }
  },
  '& .MuiInputLabel-root': {
    color: themeColors.textColor,
  }
}));

const SurveyThemeModal = ({ open, onClose, onThemeSelect, embedded = false ,savedTheme = null }) => {
  // const [selectedTheme, setSelectedTheme] = useState(0);
  // Initialize selectedTheme based on savedTheme if available
  const [selectedTheme, setSelectedTheme] = useState(() => {
    if (savedTheme) {
      const themeIndex = themes.findIndex(theme => theme.id === savedTheme.id);
      return themeIndex >= 0 ? themeIndex : 0;
    }
    return 0;
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const currentTheme = themes[selectedTheme];

// Update selected theme when savedTheme changes
useEffect(() => {
  if (savedTheme) {
    const themeIndex = themes.findIndex(theme => theme.id === savedTheme.id);
    if (themeIndex >= 0) {
      setSelectedTheme(themeIndex);
    }
  }
}, [savedTheme]);

  const handleThemeSelect = (index) => {
    setSelectedTheme(index);
 if (embedded && onThemeSelect) {
    onThemeSelect(themes[index]);
  }
  };
  const handleSelectThemeClick = () => {
  if (onThemeSelect) {
    onThemeSelect(themes[selectedTheme]);
  }
};

  const renderContent = () => (
    <Stack direction="column" height="100%">          {/* Enhanced Header */}
          <Box sx={{ 
            p: { xs: 2, sm: 2.5 }, 
            borderBottom: '1px solid',
            borderColor: 'divider',
            background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)'
          }}>
            <Box sx={{ maxWidth: 800 }}>
              <Typography variant="h4" sx={{ 
                fontSize: { xs: '1.25rem', sm: '1.5rem' },
                fontWeight: 700,
                color: 'text.primary',
                textAlign: 'left',
                mb: 0.5
              }}>
                Choose Your Survey Theme
              </Typography>
              <Typography variant="body1" sx={{
                color: 'text.secondary',
                textAlign: 'left',
                fontSize: '0.9rem'
              }}>
                Select from professional themes inspired by leading SaaS companies
              </Typography>
            </Box>
          </Box>

          {/* Main Content */}
          <Stack 
            direction={{ xs: 'column', md: 'row' }} 
            spacing={3} 
            flex={1} 
            overflow="hidden"
          >
            {/* Theme Selection - Make it full width on mobile */}
            <Box sx={{ 
              width: { xs: '100%', md: '320px' },
              flex: { xs: 1, md: 'none' },
              p: 3,
              // height: 'calc(90vh - 200px)',
              overflowY: 'auto',
              borderRight: { xs: 'none', md: '1px solid' },
              borderColor: 'divider',
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
                '&:hover': {
                  background: '#555',
                },
              },
            }}>
              <Stack spacing={2}>
                {/* Optionally add mobile hint */}
                <Box sx={{ 
                  display: { xs: 'block', md: 'none' },
                  mb: 2,
                  textAlign: 'center'
                }}>
                  <Typography
                    sx={{ 
                      color: 'text.secondary',
                      fontSize: '0.875rem'
                    }}
                  >
                    Select a theme to customize your survey
                  </Typography>
                </Box>
                  {/* Theme cards with improved design */}
                {themes.map((themeOption, index) => (
                  <ThemeCard
                    key={themeOption.id}
                    isSelected={selectedTheme === index}
                    themeColors={themeOption}
                    onClick={() => handleThemeSelect(index)}
                    elevation={selectedTheme === index ? 8 : 1}
                  >
                    <Stack spacing={2}>
                      {/* Theme Header with Selection Indicator */}
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography sx={{ 
                          color: themeOption.textColor,
                          fontWeight: 600,
                          fontSize: '1rem',
                          fontFamily: "'Inter', system-ui, sans-serif"
                        }}>
                          {themeOption.name}
                        </Typography>
                        {selectedTheme === index && (
                          <Box
                            sx={{
                              width: 20,
                              height: 20,
                              borderRadius: '50%',
                              backgroundColor: themeOption.accentColor,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                          >
                            <Box
                              sx={{
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                backgroundColor: 'white'
                              }}
                            />
                          </Box>
                        )}
                      </Box>
                      
                      {/* Enhanced Preview Section */}
                      <Box
                        sx={{
                          background: themeOption.bg,
                          borderRadius: 2,
                          p: 2,
                          border: `1px solid ${themeOption.borderColor}`,
                          minHeight: 80
                        }}
                      >
                        {/* Mini Form Preview */}
                        <Stack spacing={1.5}>
                          {/* Form Title */}
                          <Box
                            sx={{
                              height: 8,
                              backgroundColor: themeOption.textColor,
                              borderRadius: 1,
                              width: '70%',
                              opacity: 0.8
                            }}
                          />
                          
                          {/* Input Field */}
                          <Box
                            sx={{
                              height: 28,
                              backgroundColor: themeOption.inputBg,
                              border: `1px solid ${themeOption.borderColor}`,
                              borderRadius: 1,
                              display: 'flex',
                              alignItems: 'center',
                              px: 1
                            }}
                          >
                            <Box
                              sx={{
                                height: 6,
                                backgroundColor: themeOption.textColor,
                                borderRadius: 0.5,
                                width: '40%',
                                opacity: 0.4
                              }}
                            />
                          </Box>
                          
                          {/* Button Preview */}
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Box
                              sx={{
                                height: 20,
                                backgroundColor: themeOption.accentColor,
                                borderRadius: 1,
                                width: 40,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <Box
                                sx={{
                                  height: 4,
                                  backgroundColor: 'white',
                                  borderRadius: 0.5,
                                  width: 20
                                }}
                              />
                            </Box>
                          </Box>
                        </Stack>
                      </Box>
                      
                      {/* Color Palette */}
                      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                        {[
                          themeOption.accentColor, 
                          themeOption.secondaryColor, 
                          themeOption.textColor,
                          themeOption.borderColor
                        ].map((color, i) => (
                          <Box
                            key={i}
                            sx={{
                              width: 24,
                              height: 16,
                              borderRadius: 1,
                              backgroundColor: color,
                              border: '1px solid rgba(0,0,0,0.1)',
                              flex: 1
                            }}
                          />
                        ))}
                      </Stack>
                      
                      {/* Theme Category Badge */}
                      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <Typography
                          sx={{
                            fontSize: '0.75rem',
                            color: themeOption.textColor,
                            opacity: 0.6,
                            fontWeight: 500,
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}
                        >
                          {themeOption.name.includes('Google') ? '🔵 Google' :
                           themeOption.name.includes('Slack') ? '💬 Slack' :
                           themeOption.name.includes('Notion') ? '📝 Notion' :
                           themeOption.name.includes('Linear') ? '📐 Linear' :
                           themeOption.name.includes('Stripe') ? '💳 Stripe' :
                           themeOption.name.includes('GitHub') ? '🐙 GitHub' :
                           themeOption.name.includes('Dark') || themeOption.name.includes('Discord') ? '🌙 Dark' :
                           themeOption.name.includes('Figma') ? '🎨 Design' :
                           themeOption.name.includes('Spotify') ? '🎵 Music' :
                           themeOption.name.includes('Twitter') ? '🐦 Social' :
                           '🎨 Creative'}
                        </Typography>
                      </Box>
                    </Stack>
                  </ThemeCard>
                ))}
              </Stack>
            </Box>            {/* Enhanced Preview Section - Hide on mobile */}
            <Box sx={{ 
              flex: 1,
              overflowY: 'auto',
              p: 3,
              display: { xs: 'none', md: 'block' },
              maxHeight: 'calc(90vh - 200px)' // Ensure it doesn't exceed modal height
            }}>
              
              <PreviewSection sx={{ 
                background: currentTheme.gradientBg,
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                border: '1px solid',
                borderColor: currentTheme.borderColor,
                borderRadius: '12px',
                overflow: 'visible',
                minHeight: 'fit-content',
                height: 'auto'
              }}>
                {/* Survey Header */}
                <Box sx={{
                  background: currentTheme.bg,
                  p: 3,
                  borderBottom: `1px solid ${currentTheme.borderColor}`
                }}>
                  <Typography 
                    variant="h5" 
                    sx={{ 
                      color: currentTheme.textColor, 
                      fontWeight: 700,
                      fontFamily: "'Inter', system-ui, sans-serif",
                      fontSize: '1.5rem',
                      mb: 1
                    }}
                  >
                    Customer Satisfaction Survey
                  </Typography>
                  <Typography 
                    sx={{ 
                      color: currentTheme.textColor, 
                      opacity: 0.7,
                      fontFamily: "'Inter', system-ui, sans-serif",
                      fontSize: '1rem'
                    }}
                  >
                    Help us improve your experience
                  </Typography>
                </Box>

                {/* Survey Content */}
                <Box sx={{ 
                  background: currentTheme.bg,
                  p: 4
                }}>
                  {/* Email Question */}
                  <Box sx={{ mb: 4, textAlign: 'left' }}>
                    <Typography sx={{ 
                      color: currentTheme.textColor, 
                      mb: 2,
                      fontWeight: 600,
                      fontSize: '1.1rem'
                    }}>
                      What's your email address? <span style={{ color: currentTheme.accentColor }}>*</span>
                    </Typography>
                    <StyledTextField
                      fullWidth
                      placeholder="your@email.com"
                      disabled
                      themeColors={currentTheme}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '8px',
                          fontSize: '1rem'
                        }
                      }}
                    />
                  </Box>

                  {/* Rating Question */}
                  <Box sx={{ mb: 4, textAlign: 'left' }}>
                    <Typography sx={{ 
                      color: currentTheme.textColor, 
                      mb: 2,
                      fontWeight: 600,
                      fontSize: '1.1rem'
                    }}>
                      How would you rate our service?
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      {[1, 2, 3, 4, 5].map((star) => (
                        <Box
                          key={star}
                          sx={{
                            width: 32,
                            height: 32,
                            borderRadius: '50%',
                            backgroundColor: star <= 4 ? currentTheme.accentColor : alpha(currentTheme.accentColor, 0.3),
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            cursor: 'not-allowed'
                          }}
                        >
                          ★
                        </Box>
                      ))}
                    </Box>
                  </Box>

                  {/* Multiple Choice Question */}
                  <Box sx={{ mb: 4, textAlign: 'left' }}>
                    <Typography sx={{ 
                      color: currentTheme.textColor, 
                      mb: 2,
                      fontWeight: 600,
                      fontSize: '1.1rem'
                    }}>
                      Which feature do you use most?
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                      {['Analytics Dashboard', 'Team Collaboration', 'API Integration'].map((option, index) => (
                        <FormControlLabel
                          key={option}
                          control={
                            <Radio 
                              checked={index === 0}
                              disabled
                              sx={{
                                color: currentTheme.textColor,
                                '&.Mui-checked': {
                                  color: currentTheme.accentColor,
                                },
                                '&.Mui-disabled': {
                                  opacity: 0.8
                                }
                              }}
                            />
                          }
                          label={
                            <Typography sx={{ 
                              color: currentTheme.textColor,
                              fontSize: '1rem'
                            }}>
                              {option}
                            </Typography>
                          }
                        />
                      ))}
                    </Box>
                  </Box>

                  {/* Submit Button */}
                  <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant="contained"
                      disabled
                      sx={{
                        backgroundColor: currentTheme.accentColor,
                        color: 'white',
                        '&.Mui-disabled': {
                          backgroundColor: currentTheme.accentColor,
                          color: 'white',
                          opacity: 0.9
                        },
                        height: '44px',
                        px: 4,
                        fontSize: '1rem',
                        fontWeight: 600,
                        textTransform: 'none',
                        borderRadius: '8px',
                        boxShadow: `0 4px 12px ${alpha(currentTheme.accentColor, 0.3)}`
                      }}
                    >
                      Submit Survey
                    </Button>
                  </Box>
                </Box>
              </PreviewSection>
            </Box>
          </Stack>

          {/* Add footer when not embedded (opened from Dashboard) */}
    {!embedded && (
      <Box sx={{ 
        p: 3, 
        borderTop: '1px solid',
        borderColor: 'divider',
        background: '#ffffff',
        display: 'flex',
        justifyContent: 'space-between',
        gap: 2,
        flexDirection: { xs: 'column', sm: 'row' }
      }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            color: 'text.secondary',
            borderColor: 'divider',
            order: { xs: 2, sm: 1 },
            flex: { xs: 1, sm: 'none' },
            '&:hover': {
              borderColor: 'text.primary',
              backgroundColor: 'transparent'
            }
          }}
        >
          Back
        </Button>
        <Button
          variant="contained"
          onClick={handleSelectThemeClick}
          sx={{
            backgroundColor: 'primary.main',
            color: 'primary.contrastText',
            order: { xs: 1, sm: 2 },
            flex: { xs: 1, sm: 'none' },
            '&:hover': {
              backgroundColor: 'primary.dark'
            }
          }}
        >
          Select theme
        </Button>
      </Box>
    )}
        </Stack>

            )



  if (embedded) {
    return (
      <Box
        sx={{
          height: '100%',
          width: '100%',
          background: '#ffffff',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden'
        }}
      >
        {renderContent()}
      </Box>
    );
  }

  

  // return (
  //   <Dialog
  //     open={open}
  //     onClose={onClose}
  //     maxWidth="lg"
  //     fullWidth
  //     PaperProps={{
  //       sx: {
  //         borderRadius: { xs: 0, sm: 3 },
  //         height: { xs: '100vh', sm: '90vh' },
  //         maxWidth: '1300px !important',
  //         margin: { xs: 0, sm: 2 },
  //         background: '#ffffff' // Keep dialog background white
  //       }
  //     }}
  //   >
  //     <DialogContent sx={{ p: 0, height: '100%', overflow: 'hidden' }}>
  //       <Stack direction="column" height="100%">
  //         {/* Header - Keep neutral styling */}
  //         <Box sx={{ 
  //           p: 3, 
  //           borderBottom: '1px solid',
  //           borderColor: 'divider',
  //           background: '#ffffff'
  //         }}>
  //           <Typography variant="h4" sx={{ 
  //             fontSize: { xs: '1.5rem', sm: '1.875rem' },
  //             fontWeight: 700,
  //             color: 'text.primary',
  //             textAlign: { xs: 'center', sm: 'left' }
  //           }}>
  //             Choose your survey theme
  //           </Typography>
  //         </Box>

  //         {/* Main Content */}
  //         <Stack 
  //           direction={{ xs: 'column', md: 'row' }} 
  //           spacing={3} 
  //           flex={1} 
  //           overflow="hidden"
  //         >
  //           {/* Theme Selection - Make it full width on mobile */}
  //           <Box sx={{ 
  //             width: { xs: '100%', md: '320px' },
  //             flex: { xs: 1, md: 'none' },
  //             p: 3,
  //             overflowY: 'auto',
  //             borderRight: { xs: 'none', md: '1px solid' },
  //             borderColor: 'divider'
  //           }}>
  //             <Stack spacing={2}>
  //               {/* Optionally add mobile hint */}
  //               <Box sx={{ 
  //                 display: { xs: 'block', md: 'none' },
  //                 mb: 2,
  //                 textAlign: 'center'
  //               }}>
  //                 <Typography
  //                   sx={{ 
  //                     color: 'text.secondary',
  //                     fontSize: '0.875rem'
  //                   }}
  //                 >
  //                   Select a theme to customize your survey
  //                 </Typography>
  //               </Box>
                
  //               {/* Existing theme cards */}
  //               {themes.map((themeOption, index) => (
  //                 <ThemeCard
  //                   key={themeOption.id}
  //                   isSelected={selectedTheme === index}
  //                   themeColors={themeOption}
  //                   onClick={() => setSelectedTheme(index)}
  //                   elevation={selectedTheme === index ? 8 : 1}
  //                 >
  //                   <Stack spacing={2}>
  //                     <Typography sx={{ 
  //                       color: themeOption.textColor,
  //                       fontWeight: 600,
  //                       fontSize: '1rem'
  //                     }}>
  //                       {themeOption.name}
  //                     </Typography>
                      
  //                     {/* Theme Preview Strip */}
  //                     <Stack direction="row" spacing={1}>
  //                       {[themeOption.accentColor, themeOption.secondaryColor].map((color, i) => (
  //                         <Box
  //                           key={i}
  //                           sx={{
  //                             width: 40,
  //                             height: 24,
  //                             borderRadius: 1,
  //                             backgroundColor: color
  //                           }}
  //                         />
  //                       ))}
  //                     </Stack>
  //                   </Stack>
  //                 </ThemeCard>
  //               ))}
  //             </Stack>
  //           </Box>

  //           {/* Preview Section - Hide on mobile */}
  //           <Box sx={{ 
  //             flex: 1,
  //             overflowY: 'auto',
  //             p: 3,
  //             display: { xs: 'none', md: 'block' }
  //           }}>
  //             <PreviewSection sx={{ 
  //               background: currentTheme.bg,
  //               boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
  //               border: '1px solid',
  //               borderColor: 'divider',
  //             }}>
  //               <Box sx={{ 
  //                 maxWidth: 600, 
  //                 mx: 'auto', 
  //                 mt: 4,
  //                 textAlign: 'center',
  //                 position: 'relative',
  //                 zIndex: 0
  //               }}>
  //                 <Typography 
  //                   variant="h4" 
  //                   sx={{ 
  //                     color: currentTheme.textColor, 
  //                     mb: 1,
  //                     fontFamily: "'Inter', sans-serif",
  //                     fontWeight: 600,
  //                     fontSize: '1.5rem'
  //                   }}
  //                 >
  //                   Example form with theme
  //                 </Typography>
  //                 <Typography 
  //                   sx={{ 
  //                     color: currentTheme.textColor, 
  //                     opacity: 0.7, 
  //                     mb: 4,
  //                     fontFamily: "'Inter', sans-serif",
  //                     fontSize: '0.875rem'
  //                   }}
  //                 >
  //                   Create form to get started
  //                 </Typography>

  //                 <Box sx={{ mb: 3, textAlign: 'left' }}>
  //                   <StyledTextField
  //                     fullWidth
  //                     label="What is your email?"
  //                     required
  //                     disabled
  //                     themeColors={currentTheme}
  //                     InputProps={{
  //                       startAdornment: <EmailIcon sx={{ mr: 1, color: currentTheme.textColor }} />,
  //                     }}
  //                   />
  //                 </Box>

  //                 <Box sx={{ mb: 3, textAlign: 'left' }}>
  //                   <Typography sx={{ 
  //                     color: currentTheme.textColor, 
  //                     mb: 2,
  //                     fontWeight: 500 
  //                   }}>
  //                     Would you like to subscribe?
  //                   </Typography>
  //                   <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
  //                     <FormControlLabel
  //                       control={
  //                         <Radio 
  //                           disabled
  //                           sx={{
  //                             color: currentTheme.textColor,
  //                             '&.Mui-checked': {
  //                               color: currentTheme.accentColor,
  //                             },
  //                             '&.Mui-disabled': {
  //                               opacity: 0.6
  //                             }
  //                           }}
  //                         />
  //                       }
  //                       label="Yes"
  //                       sx={{ color: currentTheme.textColor }}
  //                     />
  //                     <FormControlLabel
  //                       control={
  //                         <Radio 
  //                           disabled
  //                           sx={{
  //                             color: currentTheme.textColor,
  //                             '&.Mui-checked': {
  //                               color: currentTheme.accentColor,
  //                             },
  //                             '&.Mui-disabled': {
  //                               opacity: 0.6
  //                             }
  //                           }}
  //                         />
  //                       }
  //                       label="No"
  //                       sx={{ color: currentTheme.textColor }}
  //                     />
  //                   </Box>
  //                 </Box>

  //                 <Box sx={{ mb: 4, textAlign: 'left' }}>
  //                   <FormControlLabel
  //                     control={
  //                       <Checkbox 
  //                         disabled
  //                         sx={{
  //                           color: currentTheme.textColor,
  //                           '&.Mui-checked': {
  //                             color: currentTheme.accentColor,
  //                           },
  //                           '&.Mui-disabled': {
  //                             opacity: 0.6
  //                           }
  //                         }}
  //                       />
  //                     }
  //                     label={
  //                       <Box>
  //                         <Typography sx={{ color: currentTheme.textColor }}>
  //                           Do you agree to the terms & conditions
  //                         </Typography>
  //                         <Typography sx={{ 
  //                           color: currentTheme.textColor, 
  //                           opacity: 0.7, 
  //                           fontSize: '0.875rem'
  //                         }}>
  //                           More details on our site
  //                         </Typography>
  //                       </Box>
  //                     }
  //                   />
  //                 </Box>

  //                 <Button
  //                   fullWidth
  //                   variant="contained"
  //                   disabled
  //                   sx={{
  //                     backgroundColor: currentTheme.accentColor,
  //                     color: currentTheme.bg === '#FFFFFF' ? '#FFFFFF' : currentTheme.textColor,
  //                     '&.Mui-disabled': {
  //                       backgroundColor: currentTheme.accentColor,
  //                       color: currentTheme.bg === '#FFFFFF' ? '#FFFFFF' : currentTheme.textColor,
  //                     },
  //                     height: '42px',
  //                     fontSize: '0.875rem',
  //                     fontWeight: 500,
  //                     textTransform: 'none',
  //                     borderRadius: '6px'
  //                   }}
  //                 >
  //                   Submit  <span style={{ marginLeft: '4px' }}>✓</span>
  //                 </Button>
  //               </Box>
  //             </PreviewSection>
  //           </Box>
  //         </Stack>

  //         {/* Footer - Keep neutral styling */}
  //         <Box sx={{ 
  //           p: 3, 
  //           borderTop: '1px solid',
  //           borderColor: 'divider',
  //           background: '#ffffff',
  //           display: 'flex',
  //           justifyContent: 'space-between',
  //           gap: 2,
  //           flexDirection: { xs: 'column', sm: 'row' }
  //         }}>
  //           <Button
  //             onClick={onClose}
  //             variant="outlined"
  //             sx={{
  //               color: 'text.secondary',
  //               borderColor: 'divider',
  //               order: { xs: 2, sm: 1 },
  //               flex: { xs: 1, sm: 'none' },
  //               '&:hover': {
  //                 borderColor: 'text.primary',
  //                 backgroundColor: 'transparent'
  //               }
  //             }}
  //           >
  //             Back
  //           </Button>
  //           <Button
  //             variant="contained"
  //             onClick={() => onThemeSelect(currentTheme)}
  //             sx={{
  //               backgroundColor: 'primary.main',
  //               color: 'primary.contrastText',
  //               order: { xs: 1, sm: 2 },
  //               flex: { xs: 1, sm: 'none' },
  //               '&:hover': {
  //                 backgroundColor: 'primary.dark'
  //               }
  //             }}
  //           >
  //             Create survey
  //           </Button>
  //         </Box>
  //       </Stack>
  //     </DialogContent>
  //   </Dialog>
  // );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          // borderRadius: { xs: 0, sm: 3 },
          // height: { xs: '100vh', sm: '90vh' },
          // maxWidth: '1300px !important',
          // margin: { xs: 0, sm: 2 },
          // background: '#ffffff'
           height: '90vh',
          maxWidth: '1300px'
        }
      }}
    >
      <DialogContent sx={{ p: 0, height: '100%', overflow: 'hidden' }}>
        {renderContent()}
      </DialogContent>
    </Dialog>
  );

};

export default SurveyThemeModal;
